import { ICONE } from 'icons'
import { BaseIconButtons } from 'inputs'
import { formattaData, formattaDataEOra } from 'utils'
import { useEntita } from './EntitaContext'

export default function IconaModificheBloccatePrimaDiData(props) {
  const {
    gestionePermessi: { dataCongelamento, descrDataCongelamento }
  } = useEntita()

  const { 
    data = dataCongelamento, 
    descrData = descrDataCongelamento, 
    descrIniziale = '',
    descrOggetto,
    formattaDataSenzaOra = false,
    ...restProps
  } = props

  let tooltip = `${descrIniziale} Modifiche bloccate per ${descrOggetto} ${formattaDataSenzaOra ? formattaData(data) : formattaDataEOra(data)}`
  if (descrData) tooltip += ` (${descrData})`

  return (
    <BaseIconButtons.Custom
      contenutoTooltip={tooltip}
      Icon={ICONE.LUCCHETTO_CHIUSO}
      color='success'
      {...restProps}
    />
  )
}